import { useQuery } from "@apollo/client";

import { COMPETITION_CLIPS } from "MVVM/GraphQL/competitions";
import { useUser } from "MVVM/Hooks/useUser";

export const ClipSelectorViewModel = ({ cardIds }: { cardIds: string[] }) => {
  const { allstarUser } = useUser();
  const { data, loading, error } = useQuery(COMPETITION_CLIPS, {
    variables: {
      cardIds,
      userId: allstarUser?.user?._id,
      limit: 999,
      maxAgeDays: 1,
    },
  });

  return {
    competitionClips: data?.creatorCardClips,
    loading,
    error,
  };
};
